import React from "react";

export function WorkflowStepHeader({ children }: any) {
  return <div className="gui-workflow-step__header">{children}</div>;
}
